/**
 * 参数检验
 */
function Validate() {
  // do nothing
}

/**
 * 判断对象是否有属性
 * @param {*} value
 * @param {*} key
 * @returns
 */
Validate.hasProperty = function (value, key) {
  return value && value[key] !== undefined;
};

/**
 * 判断是否数组
 * @param {*} value
 * @returns
 */
Validate.isArray = function (value) {
  return Object.prototype.toString.call(value) === '[object Array]';
};

/**
 * 判断值是布尔值
 * @param {*} value
 * @returns
 */
Validate.isBool = function (value) {
  return Object.prototype.toString.call(value) === '[object Boolean]';
};

/**
 * 判断是否对象
 * @param {*} value
 * @returns
 */
Validate.isObject = function (value) {
  return Object.prototype.toString.call(value) === '[object Object]';
};

Validate.isString = function (value) {
  return Object.prototype.toString.call(value) === '[object String]';
};

/**
 * 手机号检验
 * @param {String} val
 * @returns
 */
Validate.isMobile = function (val) {
  return typeof val === 'string' && /^1[0-9]{10}$/i.test(val);
};

Validate.checkImgCode = function (code) {
  return /^[0-9a-zA-Z]{4}$/i.test(code);
};

Validate.returnValueIsNotNull = function (str) {
  return Validate.isEmpty(str) ? '' : str;
};

Validate.isNull = function (str) {
  return typeof str == 'undefined' || str == null || str === undefined || str === '';
};

/**
 * 判断常规空值
 * @param {Any} val /
 * @returns Boolean
 */
Validate.isBlank = function (val) {
  return [NaN, null, undefined, ''].includes(val);
};

/**
 * 判断业务空值
 * @param {Any} val /
 * @returns Boolean
 */
Validate.isEmpty = function (val) {
  return (
    Validate.isBlank(val) ||
    ['NULL', 'null', 'undefined'].includes(val) ||
    String(val).trim() === ''
  );
};

/**
 * 判断业务非空值
 * @param {Any} val /
 * @returns Boolean
 */
Validate.isNotEmpty = function (val) {
  return !Validate.isEmpty(val);
};

/**
 * 判断是否金额 最多两位小数
 * @param {Number|String} val 金额 数值或字符串
 * @returns
 */
Validate.isMoney = function (val) {
  val = '' + val;
  return (/^\d+(\.\d{1,2}|\d*)$/.test(val) && /^[^0]/.test(val)) || /^0\.\d{1,2}$/.test(val);
};

/**
 * 判断是否为有效邮箱地址
 * @param {Number|String} val 金额 数值或字符串
 * @returns
 */
Validate.isEmail = function (val) {
  return /^\w{3,}(\.\w+)*@[A-z 0-9]+(\.[A-z]{2,5}){1,2}$/.test(val);
};

/**
 * 判断是否为安全内容，不包含特殊字符
 * @param {Number|String} val 金额 数值或字符串
 * @returns
 */
Validate.isSafe = function (val) {
  return !/["'<>%;)(&+]/.test(val);
};

/**
 * 基于规则判断输入值是否合法
 * @param {Number|String} val 金额 数值或字符串
 * @param {[string]} rules 需要校验的规则
 * @returns
 */
Validate.validateByRule = function (val, rules = []) {
  if (!Array.isArray(rules)) return;
  const failedRules = ['safe', ...rules].filter((rule) => !ruleValidators[rule].validate(val));

  return {
    result: !failedRules.length,
    failed: failedRules,
    message: failedRules.length
      ? failedRules.map((rule) => ruleValidators[rule].message)
      : '校验通过'
  };
};

// 校验规则和方法
const ruleValidators = {
  safe: {
    validate: Validate.isSafe,
    message: `输入内容不得包含<>"':)(&+等特殊字符!`
  },
  notEmpty: {
    validate: Validate.isNotEmpty,
    message: '内容不可为空!'
  },
  email: {
    validate: Validate.isEmail,
    message: '请输入正确的邮箱格式!'
  },
  money: {
    validate: Validate.isMoney,
    message: '请输入正确的金额!'
  },
  mobile: {
    validate: Validate.isMobile,
    message: '请输入正确的电话号码!'
  }
};

export default Validate;



// WEBPACK FOOTER //
// ./src/utils/validate.js